// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xi_a bhm_vp bhm_vh bhm_xe bhm_rg bhm_tr bhm_qx"};